module.exports = __webpack_public_path__ + "static/media/prescription-delivery-disclaimer.b1d8a5e4.svg";